<template>
    <el-container>
        <el-header style="height: auto">
            <el-row>
                <el-form :inline="true" :model="logSettingForm" ref="logSettingForm" label-width="70px">
                    <td-permission :roles="roles" style="float:right;">
                        <div slot="havePermission">
                            <el-form-item :label="$t('common.CURSYS')">
                                <td-select
                                    v-model="sSysFlg"
                                    :placeholder="$t('common.PLEASE_SELECT')"
                                    @change="queryPageBySys()"
                                    :options="this.sysAndFlgList"
                                    keys="sSysFlg"
                                    text="sName"
                                    :clearable="false"
                                >
                                </td-select>
                            </el-form-item>
                        </div>
                    </td-permission>
                    <td-permission :permissions="permissionsQuery">
                        <div slot="havePermission">
                            <el-form-item :label="$t('logCommon.RES_TYPE')" prop="resTypeId">
                                <td-select
                                    ref="resType"
                                    v-model="logSettingForm.resTypeId"
                                    :options="resOptions"
                                    keys="value"
                                    text="label"
                                    :multiple="multiple"
                                    @clear="clear"
                                    @removeTag="removeTag"
                                    :collapse-tags="collapse"
                                    @change="changeResType"
                                ></td-select>
                            </el-form-item>
                        </div>
                    </td-permission>
                    <td-permission :oneOfPermissions="permissionsQuery">
                        <div slot="havePermission">
                            <el-form-item :label="$t('logCommon.AUTH_TYPE')" prop="authTypeId">
                                <td-select v-model="logSettingForm.authTypeId" :options="authOptions" keys="value" text="label" :multiple="multiple" :collapse-tags="collapse" @change="changeAuthType"></td-select>
                            </el-form-item>
                        </div>
                    </td-permission>
                    <td-permission :oneOfPermissions="permissionsQuery">
                        <div slot="havePermission">
                            <el-form-item :label="$t('logCommon.SAVE_FLG')" prop="saveFlg">
                                <td-select v-model="logSettingForm.saveFlg" :options="saveFlgOptions" keys="value" text="label" :collapse-tags="collapse"></td-select>
                            </el-form-item>
                        </div>
                    </td-permission>
                    <el-form-item style="padding-left:10px">
                        <td-button type="primary" :permissions="permissionsQuery" @click="btnClickQuery" :loading="btnQueLoading">{{ $t('logCommon.QUERY') }}</td-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <!-- <el-row> -->
                <td-button type="button" :permissions="permissionsAdd" @click="btnAdd">{{ $t('logCommon.ADD') }}</td-button>
                <td-button type="button" :permissions="permissionsEdit" @click="btnBatchTurnOn" :loading="btnBatchTurnOnLoading">{{ $t('logCommon.BATCH_TURN_ON') }}</td-button>
                <td-button type="button" :permissions="permissionsEdit" @click="btnBatchTurnOff" :loading="btnBatchTurnOffLoading">{{ $t('logCommon.BATCH_TURN_OFF') }}</td-button>
            <!-- </el-row> -->
        </el-header>
        <el-main>
            <el-row style="margin-top:20px;">
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :rowKey="rowKey"
                :total="total"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :permissions="permissionsQuery"
                :hasLoading="tableLoading"
                :hasMutiSelect="multiple"
                ref="logSettingInfo"
            ></td-table>
            </el-row>
            <dialogAddLogSetting
                v-if="dialogAddVisible"
                :dialogAddVisible="dialogAddVisible"
                :title="title"
                :sSysFlg="sSysFlg"
                :isAddData="isAddData"
                :editItem="editItem"
                @dialogClose="dialogClose"
                @dialogSaveClose="dialogSaveClose"
            ></dialogAddLogSetting>
        </el-main>
    </el-container>
</template>
<script>
import api from './assets/api.js';
import dialogAddLogSetting from './components/dialogAddLogSetting.vue';
export default {
    // 初始化渲染
    components: {
        dialogAddLogSetting: dialogAddLogSetting
    },
    created() {
        if (this.$common.systemInfo.systemId) {
            this.sSysFlg = this.$common.systemInfo.systemId;
        } else {
            this.sSysFlg = 'PG';
        }
        api.getSysList(JSON.stringify(''), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                this.$log.error('sys/getSysList', response.data.statusMessage);
            }
            this.sysList = response.data.content;
            this.sysAndFlgList = [];
            for (let index = 0; index < this.sysList.length; index++) {
                let element = this.sysList[index];
                this.sysAndFlgList.push({ sName: element.sName + '：' + element.sSysFlg, sSysFlg: element.sSysFlg });
            }
        });
    },
    mounted() {
        // 获取系统标识
        this.queryPageBySys();
    },
    data() {
        return {
            permissionsQuery: ['logSetting:view'],
            permissionsAdd: ['logSetting:add'],
            permissionsEdit: ['logSetting:edit'],
            isAddData: true, // 是否为添加数据
            editItem: '',
            logSettingForm: {
                resTypeId: [],
                authTypeId: []
            },
            resOptions: [],
            authOptions: [],
            resOptionsValues: [],
            authOptionsValues: [],
            saveFlgOptions: [{
                value: 0,
                label: this.$t('logCommon.TURN_OFF')
            }, {
                value: 1,
                label: this.$t('logCommon.TURN_ON')
            }],
            rowKey: 'id',

            multiple: true,
            collapse: true,
            saveFlg: 0,
            btnQueLoading: false,
            btnBatchTurnOnLoading: false,
            btnBatchTurnOffLoading: false,
            tableLoading: false,
            tableData: [],
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            columns: [
                {
                    prop: 'resTypeName',
                    label: 'logCommon.RES_TYPE',
                    align: 'left'
                },
                {
                    prop: 'authTypeName',
                    label: 'logCommon.AUTH_TYPE',
                    align: 'left'
                },
                {
                    prop: 'templateName',
                    label: 'logCommon.TEMPLATE',
                    align: 'left'
                },
                {
                    prop: 'saveFlg',
                    label: 'logCommon.SAVE_FLG',
                    align: 'center',
                    render: (createElement, params) => {
                        let saveFlg = params.row.saveFlg;
                        if (!this.$util.isEmpty(saveFlg)) {
                            let edit = createElement(
                                'td-switch', {
                                    props: {
                                        type:Number,
                                        activeValue:1,
                                        inactiveValue:0,
                                        value:saveFlg,
                                        activeText:'', 
                                        inactiveText:'',
                                        permissions:this.permissionsEdit},
                                    on: {
                                        change: () => {
                                            this.changeSaveFlg(params.row);
                                        }
                                    }
                                }
                            );
                            return createElement('div', [edit]);
                        } else {
                            return createElement('div', this.$t('logCommon.BLANK'));
                        }
                    }
                },
                {
                    label: 'logCommon.OPERATE',
                    align: 'center',
                    tableWidth: '120',
                    render: (createElement, params) => {
                        let edit = createElement(
                            'td-button',
                            {
                                props: { type: 'text', size: 'small', permissions: this.permissionsEdit},
                                on: {
                                    click: () => {
                                        this.btnEdit(params.row);
                                    }
                                }
                            },
                            this.$t('logCommon.EDIT')
                        );
                        let list = [edit];
                        return createElement('div', list);
                    }
                }
            ],
            title: '',
            editItem: '',
            sSysFlg: '',
            sysList: [],
            sysAndFlgList: [],
            dialogAddVisible: false
        };
    },
    // 方法的实现
    methods: {
        // 系统标识转换监听
        queryPageBySys() {
            this.resOptions = [];
            this.resOptionsValues = [];
            this.logSettingForm.resTypeId = [];
            this.logSettingForm.authTypeId = [];
            this.authOptions = [];
            this.authOptionsValues = [];
            this.sysFlg = this.logSettingForm.sSysFlg;
            // 获取操作权限类型列表
            this.queryOperationType();
            // 获取资源类型列表
            this.getAllResType();
        },
        // 获取资源类型列表
        getAllResType() {
            let allResTypeParam = { 
                sSysFlg: this.sSysFlg 
            };
            api.getAllResType(JSON.stringify(allResTypeParam), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/logSettingManager/getAllResType', response);
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/logSettingManager/getAllResType', response.data.statusMessage);
                    return;
                }
                let typeList = response.data.content;
                if (typeList && typeList.length != 0) {
                    this.resOptions = [
                        {
                            value: 'all',
                            label: this.$t('common.ALL')
                        }
                    ];
                    for (let i = 0; i < typeList.length; i++) {
                        let temValue = typeList[i];
                        let item = {
                            value: temValue.sId,
                            label: temValue.sName
                        };
                        this.resOptions.push(item);
                        this.resOptionsValues.push(item.value);
                    }
                }
                this.btnClickQuery();
            });
        },
        // 获取操作权限类型列表
        queryOperationType() {
            let operationTypeParam = {
                sSysFlg: this.sSysFlg 
            };
            api.queryOperationType(JSON.stringify(operationTypeParam), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/logSettingManager/queryOperationType', response);
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('/logSettingManager/queryOperationType', response.data.statusMessage);
                    return;
                }
                let typeList = response.data.content;
                if (typeList && typeList.length != 0) {
                    this.authOptions = [
                        {
                            value: 'all',
                            label: this.$t('common.ALL')
                        }
                    ];
                    for (let i = 0; i < typeList.length; i++) {
                        let temValue = typeList[i];
                        let item = {
                            value: temValue.sId,
                            label: temValue.sCaption
                        };
                        this.authOptions.push(item);
                        this.authOptionsValues.push(item.value);
                    }
                }
                this.btnClickQuery();
            });
        },
        clear() {
            this.$refs.resType.value = [];
        },
        removeTag() {
            this.$refs.resType.value.splice(0, 1);
        },
        //资源类型变化事件监听
        changeResType: function(data) {
            this.$nextTick(function() {
                if (data && data.length > 1 && data.indexOf('all') > -1) {
                    if (data[0] === 'all') {
                        data.splice(0, 1);
                        this.logSettingForm.resTypeId = data;
                    } else {
                        this.logSettingForm.resTypeId = ['all'];
                    }
                }
                this.$refs.resType.value = data;
            });
        },
        //操作类型变化事件监听
        changeAuthType: function(data) {
            this.$nextTick(function() {
                if (data && data.length > 1 && data.indexOf('all') > -1) {
                    if (data[0] === 'all') {
                        data.splice(0, 1);
                        this.logSettingForm.authTypeId = data;
                    } else {
                        this.logSettingForm.authTypeId = ['all'];
                    }
                }
            });
        },
        // 批量编辑
        btnBatchTurnOn() {
            let param = {
                sIdList: [],
                saveFlg : 1
            };
            this.btnBatchTurnOnLoading = true;
            this.batchEdit(param);
        },
        btnBatchTurnOff() {
            let param = {
                sIdList: [],
                saveFlg : 0
            };
            this.btnBatchTurnOffLoading = true;
            this.batchEdit(param);
        },
        // 编辑
        batchEdit(param) {
            let data = this.$refs.logSettingInfo.getSelectAllRows();
            if (data.length === 0) {
                this.$message({ showClose: true, message: this.$t('common.PLEASE_SELECT'), type: 'warning' });
                this.btnBatchTurnOnLoading = false;
                this.btnBatchTurnOffLoading = false;
                return;
            }
            this.tableLoading = true;
            let list = [];
            data.forEach(element => {
                list.push(element.id);
            });
            param.sIdList = list;
            api.batchUpdateLogSetting(JSON.stringify(param), response => {
                this.tableLoading = false;
                this.btnBatchTurnOnLoading = false;
                this.btnBatchTurnOffLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                this.btnQuery();
            });
        },
        changeSaveFlg(row) {
            let param = {
                sIdList: row.id,
                saveFlg : row.saveFlg == 0?1:0
            };
            this.tableLoading = true;
            api.batchUpdateLogSetting(JSON.stringify(param), response => {
                this.tableLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.$message({ showClose: true, message: response.data.statusMessage, type: 'success' });
                this.btnQuery();
            });
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.currentPage = 1;
            this.btnQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.btnQuery();
        },
        //查询点击按钮
        btnClickQuery() {
            this.currentPage = 1;
            this.btnQuery();
        },
        btnQuery() {
            if (this.resOptionsValues.length == 0 || this.authOptionsValues.length == 0) {
                this.btnQueLoading = false;
                this.tableLoading = false;
                this.tableData = null;
                this.total = 0;
                return;
            }
            this.btnQueLoading = true;
            this.tableLoading = true;
            let param = {
                resTypeIdList: this.logSettingForm.resTypeId,
                authTypeIdList: this.logSettingForm.authTypeId,
                pageSize: this.pageSize,
                pageNum: this.currentPage,
                saveFlg: this.logSettingForm.saveFlg
            };
            if (this.logSettingForm.resTypeId && this.logSettingForm.resTypeId.indexOf('all') > -1) {
                param.resTypeIdList = this.resOptionsValues;
            }
            if (this.logSettingForm.authTypeId && this.logSettingForm.authTypeId.indexOf('all') > -1) {
                param.authTypeIdList = this.authOptionsValues;
            }
            api.queryLogSetting(JSON.stringify(param), response => {
                this.btnQueLoading = false;
                this.tableLoading = false;
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/logSettingManager/queryLogSetting', response.data.statusMessage);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
            });
        },
        //添加
        btnAdd() {
            this.isAddData = true;
            this.dialogAddVisible = true;
            this.title = this.$t('logCommon.ADD_LOG_SETTING');
        },
        // 编辑
        btnEdit(val) {
            this.editItem = val;
            this.isAddData = false;
            this.dialogAddVisible = true;
            this.title = this.$t('logCommon.EDIT_LOG_SETTING');
        },
        // 关闭dialog
        dialogClose() {
            this.dialogAddVisible = false;
        },
        // 保存关闭dialog
        dialogSaveClose() {
            this.dialogAddVisible = false;
            this.btnClickQuery();
        }
    }
};
</script>